/**
 * Canonical System support ticket identity for operator UI.
 * Prefer public_number; fall back to defined_id only for historical rows.
 */
export function supportTicketDisplayId(ticket) {
  if (!ticket || typeof ticket !== 'object') {
    return '';
  }

  const publicNumber = typeof ticket.public_number === 'string' ? ticket.public_number.trim() : '';
  if (publicNumber) {
    return publicNumber;
  }

  const definedId = typeof ticket.defined_id === 'string' ? ticket.defined_id.trim() : '';
  if (definedId) {
    return definedId;
  }

  if (ticket.id != null) {
    return String(ticket.id);
  }

  return '';
}

export function supportTicketSubject(ticket) {
  if (!ticket || typeof ticket !== 'object') {
    return '';
  }

  return ticket.theme || ticket.subject || '';
}

export function supportTicketLastActivity(ticket) {
  if (!ticket || typeof ticket !== 'object') {
    return null;
  }

  return ticket.last_message_at || ticket.updated_at || null;
}

export function supportTicketIsUnread(ticket) {
  if (!ticket || typeof ticket !== 'object') {
    return false;
  }

  return Boolean(ticket.unread_for_internal || ticket.is_unread);
}
